/**
 * Label for a timezone the fixed dropdown list lacks: its city and short
 * abbreviation, e.g. "Phoenix (MST)", matching the "(ABBR)" suffix that
 * `getTimezoneAbbreviation` reads. Falls back to the city alone when the
 * abbreviation is only a GMT offset, and to the id for an unknown zone.
 */
export const getTimezoneOptionLabel = (
  timezone: string,
  date: Date = new Date(),
): string => {
  const city = timezone.split("/").pop()?.replace(/_/g, " ") ?? timezone;
  try {
    const abbreviation = new Intl.DateTimeFormat("en-US", {
      timeZone: timezone,
      timeZoneName: "short",
    })
      .formatToParts(date)
      .find((part) => part.type === "timeZoneName")?.value;
    const isNamedAbbreviation =
      !!abbreviation &&
      /^[A-Z]{2,5}$/.test(abbreviation) &&
      !/^(GMT|UTC)$/.test(abbreviation);
    return isNamedAbbreviation ? `${city} (${abbreviation})` : city;
  } catch {
    return timezone;
  }
};
